import { motion } from 'framer-motion';
import type { ReactNode } from 'react';

interface Props {
  entryNumber?: string;
  title?: string;
  children: ReactNode;
}

export function MatchTicket({ entryNumber = '—', title = 'PunditXI Bracket', children }: Props) {
  return (
    <motion.div
      initial={{ scale: 0.85, opacity: 0, y: 20 }}
      animate={{ scale: 1, opacity: 1, y: 0 }}
      transition={{ type: 'spring', stiffness: 220, damping: 24 }}
      className="relative rounded-2xl bg-trophy-gold/95 text-bg-night overflow-hidden shadow-gold-glow-lg"
    >
      <div className="ticket-edge-top h-3" />
      <div className="px-5 py-5 space-y-3">
        <div className="flex items-baseline justify-between">
          <span className="font-display-alt text-[10px] uppercase tracking-widest">Entry</span>
          <span className="font-mono text-sm tabular-nums">#{entryNumber}</span>
        </div>
        <div className="font-display text-3xl uppercase tracking-wide leading-tight">{title}</div>
        <div className="border-t-2 border-dashed border-bg-night/30 pt-3 space-y-2 text-sm">
          {children}
        </div>
      </div>
      <div className="ticket-edge-bottom h-3" />
    </motion.div>
  );
}
